import { Component, OnInit } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { GetAsFormControlPipe } from '../../../pipes/get-as-form-control.pipe';

@Component({
  selector: 'shared-form-pincode',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, GetAsFormControlPipe, NgIf],
  templateUrl: './form-pincode.component.html',
  styleUrl: './form-pincode.component.scss',
})
export class FormPincodeComponent extends FormControlComponent implements OnInit {
  showPassword: boolean = false;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.control.addValidators([
      // Validators.required,
      Validators.pattern(/^\d{4}$/i),
    ]);
  }

  override getErrorMessage(): string {
    if (this.control.hasError('pattern')) {
      return 'Field should contain four numeric characters.';
    }
    return super.getErrorMessage();
  }
}
